import { render } from "./AboutComponent.vue?vue&type=template&id=1078ee53&scoped=true"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"

import "./AboutComponent.vue?vue&type=style&index=0&id=1078ee53&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1078ee53"]])

export default __exports__